/** Generated js for domain-specific scripting
 * by common\modules\domains\helpers\DomainJavascriptWriter
 */

/* Nieuws slider: Interactie: muis slepen, wheel naar horizontaal, pijltjes, klikbescherming, keyboard */
/* Interactie: muis slepen, wheel naar horizontaal, pijltjes, klikbescherming, keyboard */
(() => {
  const outer = document.getElementById('newsScroller');
  const viewport = document.getElementById('newsViewport');
  if (!outer || !viewport) return;
  const track = viewport.querySelector('.news-track');
  const prev = outer.querySelector('.news-nav.prev');
  const next = outer.querySelector('.news-nav.next');
  
  /* Stapgrootte is kaartbreedte plus gap */
  const stepSize = () => {
    const card = track.querySelector('.news-card');
    if (!card) return viewport.clientWidth * 0.9;
    const gap = parseFloat(getComputedStyle(track).gap || 16);
    return card.getBoundingClientRect().width + gap;
  };
  
  /* Pijlen klikken */
  const by = dir => viewport.scrollBy({ left: dir * stepSize(), behavior: 'smooth' });
  prev?.addEventListener('click', () => by(-1));
  next?.addEventListener('click', () => by(1));
  
  /* Keyboard op de focusbare viewport */
  viewport.addEventListener('keydown', e => {
    if (e.key === 'ArrowRight'){ e.preventDefault(); by(1); }
    if (e.key === 'ArrowLeft'){ e.preventDefault(); by(-1); }
  });
  
  /* Wheel naar horizontaal voor touchpads en muiswiel */
  const wheelToX = e => {
    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)){
      e.preventDefault();
      viewport.scrollLeft += e.deltaY;
    }
  };
  viewport.addEventListener('wheel', wheelToX, { passive:false });
  track.addEventListener('wheel', wheelToX, { passive:false });
  
  /* Desktop drag met pointer events. Touch gebruikt native scroll. */
  let down = false, startX = 0, startLeft = 0, moved = false;
  const isMouse = e => e.pointerType === 'mouse' || e.pointerType === undefined;
  
  viewport.addEventListener('pointerdown', e => {
    // Niet intercepten als op een link of button wordt geklikt
    if (e.target.closest('a, button, .btn-primary')) return;
    if (!isMouse(e)) return;
    
    down = true; 
    moved = false;
    startX = e.clientX;
    startLeft = viewport.scrollLeft;
    viewport.classList.add('is-dragging');
    viewport.setPointerCapture?.(e.pointerId);
  });
  
  viewport.addEventListener('pointermove', e => {
    if (!down) return;
    const dx = e.clientX - startX;
    if (Math.abs(dx) > 5) moved = true; // verhoogde drempel
    viewport.scrollLeft = startLeft - dx;
  });
  
  const endDrag = e => {
    if (!down) return;
    down = false;
    viewport.classList.remove('is-dragging');
    viewport.releasePointerCapture?.(e.pointerId);
  };
  
  viewport.addEventListener('pointerup', endDrag);
  viewport.addEventListener('pointerleave', endDrag);
  
  /* Klikbescherming zodat een drag geen link activeert */
  viewport.addEventListener('click', e => {
    if (moved) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
  
  /* Pijlstatus bijwerken en clipping voorkomen aan het eind */
  const updateArrows = () => {
    const max = viewport.scrollWidth - viewport.clientWidth - 1;
    if (prev) prev.disabled = viewport.scrollLeft <= 0;
    if (next) next.disabled = viewport.scrollLeft >= max;
  };
  
  viewport.addEventListener('scroll', updateArrows, { passive:true });
  window.addEventListener('resize', updateArrows);
  updateArrows();
})();



/* before after slider */
class BeforeAfter {
    constructor(enteryObject) {

        const beforeAfterContainer = document.querySelector(enteryObject.id);
        const before = beforeAfterContainer.querySelector('.bal-before');
        const beforeText = beforeAfterContainer.querySelector('.bal-beforePosition');
        const afterText = beforeAfterContainer.querySelector('.bal-afterPosition');
        const handle = beforeAfterContainer.querySelector('.bal-handle');
        var widthChange = 0;

        beforeAfterContainer.querySelector('.bal-before-inset').setAttribute("style", "width: " + beforeAfterContainer.offsetWidth + "px;")
        window.onresize = function () {
            beforeAfterContainer.querySelector('.bal-before-inset').setAttribute("style", "width: " + beforeAfterContainer.offsetWidth + "px;")
        }
        before.setAttribute('style', "width: 50%;");
        handle.setAttribute('style', "left: 50%;");

        //touch screen event listener
        beforeAfterContainer.addEventListener("touchstart", (e) => {

            beforeAfterContainer.addEventListener("touchmove", (e2) => {
                let containerWidth = beforeAfterContainer.offsetWidth;
                let currentPoint = e2.changedTouches[0].clientX;

                let startOfDiv = beforeAfterContainer.offsetLeft;

                let modifiedCurrentPoint = currentPoint - startOfDiv;

                if (modifiedCurrentPoint > 10 && modifiedCurrentPoint < beforeAfterContainer.offsetWidth - 10) {
                    let newWidth = modifiedCurrentPoint * 100 / containerWidth;

                    before.setAttribute('style', "width:" + newWidth + "%;");
                    afterText.setAttribute('style', "z-index: 1;");
                    handle.setAttribute('style', "left:" + newWidth + "%;");
                }
            });
        });

        //mouse move event listener
        beforeAfterContainer.addEventListener('mousemove', (e) => {
            let containerWidth = beforeAfterContainer.offsetWidth;
            widthChange = e.offsetX;
            let newWidth = widthChange * 100 / containerWidth;

            if (e.offsetX > 10 && e.offsetX < beforeAfterContainer.offsetWidth - 10) {
                before.setAttribute('style', "width:" + newWidth + "%;");
                afterText.setAttribute('style', "z-index:" + "1;");
                handle.setAttribute('style', "left:" + newWidth + "%;");
            }
        })

    }
}
if (document.querySelector('#beforeafterslider')) {
    new BeforeAfter({
        id: '#beforeafterslider'
    });
}

/* expander */

document.addEventListener('click', function (event) {
  const isExpandButton =
    event.target.matches('.expand-button') ||
    event.target.closest('.expand-button') !== null;

  const expanderParent = event.target.closest('.expander');

  if (isExpandButton && expanderParent) {
    event.preventDefault();
    toggleExpander(expanderParent, true);
  }
});

function toggleExpander(expanderElement, toggle) {
  if (toggle) {
    expanderElement.classList.toggle('expand');
  }
  let maxHeight = '999em';
  if (!expanderElement.classList.contains('expand')) {
    maxHeight = expanderElement.dataset.minimalHeight ?? '50px';
  }
  const contentElement = expanderElement.querySelector('.expander-content');
  if (contentElement) {
    contentElement.style.maxHeight = maxHeight;
  }
}

document.querySelectorAll('.expander').forEach(expander => {
  toggleExpander(expander, false);
});

/* ================================
   LANGUAGE SWITCHER – Definitieve versie met 2-letter codes
   Zet dit NA je HTML van de language switch en NA het laden van element.js
==================================*/

/* Configuratie */
const GT_CONFIG = {
  sourceLang: 'nl',                 // brontaal van je site
  defaultTargetLang: 'en',          // doeltaal voor eerste bezoek
  autoTranslateOnFirstVisit: false   // zet uit als je nooit auto EN wilt
};

/* Elements */
const btn  = document.getElementById('langBtn');
const menu = document.getElementById('langMenu');

/* Dropdown open/dicht */
btn.addEventListener('click', () => {
  const open = menu.hasAttribute('hidden') === false;
  if (open) {
    menu.setAttribute('hidden', '');
    btn.setAttribute('aria-expanded', 'false');
  } else {
    menu.removeAttribute('hidden');
    btn.setAttribute('aria-expanded', 'true');
  }
});
document.addEventListener('click', (e) => {
  if (!e.target.closest('.lang-switch')) {
    menu.setAttribute('hidden', '');
    btn.setAttribute('aria-expanded', 'false');
  }
});

/* Cookie helpers */
function setCookie(name, value, days, path = '/', domain) {
  const d = new Date();
  d.setTime(d.getTime() + days*24*60*60*1000);
  const expires = '; expires=' + d.toUTCString();
  const domainPart = domain ? '; domain=' + domain : '';
  document.cookie = name + '=' + value + expires + '; path=' + path + domainPart;
}
function deleteCookieEverywhere(name) {
  setCookie(name, '', -1, '/');
  const host = location.hostname.replace(/^www\./,'');
  if (host.includes('.')) setCookie(name, '', -1, '/', '.' + host);
}
function setCookieEverywhere(name, value, days) {
  setCookie(name, value, days, '/');
  const host = location.hostname.replace(/^www\./,'');
  if (host.includes('.')) setCookie(name, value, days, '/', '.' + host);
}
function getCookie(name) {
  const m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g,'\\$1') + '=([^;]*)'));
  return m ? decodeURIComponent(m[1]) : null;
}

/* Google Translate helpers */
function clearGTCookies() { deleteCookieEverywhere('googtrans'); }
function setGTCookiePath(from, to) { setCookieEverywhere('googtrans', `/${from}/${to}`, 365); }

/* Huidige taal uit cookie */
function getCurrentLangFromCookie() {
  const v = getCookie('googtrans');
  if (v && v.split('/')[2]) return v.split('/')[2];
  return GT_CONFIG.sourceLang;
}

/* Label knop zetten (altijd 2-letter code, of bijv. ZH-CN → ZH) */
function setButtonLabelByLang(lang) {
  // Neem alleen het eerste deel voor samengestelde codes (bv. zh-CN -> zh)
  const shortCode = lang.split('-')[0].toUpperCase();
  btn.textContent = shortCode + ' ˅';
}

/* Taal toepassen */
function applyLanguage(lang) {
  const select = document.querySelector('#google_translate_element select.goog-te-combo');

  if (lang === GT_CONFIG.sourceLang) {
    // Bewust terug naar brontaal
    sessionStorage.setItem('manualNLReset', '1');     // blokkeer auto EN bij reload
    setCookieEverywhere('forceNL', 'true', 365);      // onthoud keuze NL over pagina’s
    clearGTCookies();

    // Reset mogelijke Google state
    const frame = document.querySelector('iframe.goog-te-banner-frame');
    if (frame) frame.remove();

    location.reload();
    return;
  }

  // Naar een andere taal: forceNL wissen, cookie (en evt. select) zetten
  deleteCookieEverywhere('forceNL');

  if (select) {
    select.value = lang;
    select.dispatchEvent(new Event('change'));
  } else {
    setGTCookiePath(GT_CONFIG.sourceLang, lang);
    location.reload();
  }
}

/* Klikken op custom menu */
menu.addEventListener('click', (e) => {
  const li = e.target.closest('li[data-lang]');
  if (!li) return;
  const lang = li.getAttribute('data-lang');
  applyLanguage(lang);

  setButtonLabelByLang(lang);
  menu.setAttribute('hidden', '');
  btn.setAttribute('aria-expanded', 'false');
});

/* Init knoplabel bij laden */
function initLabel() {
  const forceNL = getCookie('forceNL') === 'true';
  const lang = forceNL ? GT_CONFIG.sourceLang : getCurrentLangFromCookie();
  setButtonLabelByLang(lang);

  // fallback als select later inlaadt
  const select = document.querySelector('#google_translate_element select.goog-te-combo');
  if (!select) setTimeout(initLabel, 300);
}
initLabel();

/* Automatisch vertalen op eerste bezoek, afhankelijk van config */
(function autoTranslateFirstVisit() {
  if (!GT_CONFIG.autoTranslateOnFirstVisit) return;

  const desiredPath = `/${GT_CONFIG.sourceLang}/${GT_CONFIG.defaultTargetLang}`;
  const hasGoogTrans = !!getCookie('googtrans');
  const manualReset  = sessionStorage.getItem('manualNLReset') === '1';
  const forceNL      = getCookie('forceNL') === 'true';

  if (!hasGoogTrans && !manualReset && !forceNL) {
    setCookieEverywhere('googtrans', desiredPath, 365);
  } else if (manualReset) {
    sessionStorage.removeItem('manualNLReset');
  }
})();

/**
 * OpenStreetMap Implementation for Nieuwbouw Online
 * Replaces Google Maps iframe with styled OpenStreetMap
 * Safe for all pages - only initializes when #project-map exists
 */

(function() {
    'use strict';
    
    function initMap() {
        // Exit gracefully if no map container exists on this page
        var mapContainer = document.getElementById('project-map');
        if (!mapContainer) {
            return;
        }
        
        // Check if Leaflet is available
        if (typeof L === 'undefined') {
            console.warn('Leaflet library not loaded - keeping Google Maps iframe or showing fallback');
            // Don't show error to user, just keep existing content or remove loading indicator
            var loading = mapContainer.querySelector('.map-loading');
            if (loading) {
                loading.innerHTML = '<p style="margin: 0;">Kaart wordt geladen...</p><p style="margin: 8px 0 0; font-size: 0.85rem; opacity: 0.7;">Als de kaart niet verschijnt, <a href="https://www.google.com/maps/search/?api=1&query=' + 
                    encodeURIComponent(mapContainer.getAttribute('data-geo-location')) + 
                    '" target="_blank" style="color: #d87d2f; text-decoration: underline;">open Google Maps</a></p>';
            }
            return;
        }
        
        // Get geo-location from data attribute (format: "lat,lng")
        var geoLocation = mapContainer.getAttribute('data-geo-location');
        if (!geoLocation) {
            console.warn('No geo-location data found');
            return;
        }
        
        // Parse coordinates
        var coords = geoLocation.split(',').map(function(c) { 
            return parseFloat(c.trim()); 
        });
        
        if (coords.length !== 2 || isNaN(coords[0]) || isNaN(coords[1])) {
            console.warn('Invalid geo-location format:', geoLocation);
            return;
        }
        
        var lat = coords[0];
        var lng = coords[1];
        
        try {
            // Initialize map
            var map = L.map('project-map', {
                center: [lat, lng],
                zoom: 14,
                scrollWheelZoom: false,
                zoomControl: true
            });
            
            // Add OpenStreetMap tiles
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '© OpenStreetMap',
                maxZoom: 19
            }).addTo(map);
            
            // Custom petrol marker with SVG icon instead of emoji
            var markerHtml = 
                '<div style="background-color: #2f5964; width: 40px; height: 40px; border-radius: 50% 50% 50% 0; transform: rotate(-45deg); border: 3px solid white; box-shadow: 0 4px 12px rgba(0,0,0,0.3); display: flex; align-items: center; justify-content: center;">' +
                '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(45deg); margin-top: -4px;">' +
                '<path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="white"/>' +
                '</svg>' +
                '</div>';
            
            var customIcon = L.divIcon({
                className: 'custom-map-marker',
                html: markerHtml,
                iconSize: [40, 40],
                iconAnchor: [20, 40]
            });
            
            // Add marker
            var marker = L.marker([lat, lng], {
                icon: customIcon
            }).addTo(map);
            
            // Add popup
            var popupContent = 
                '<div style="font-family: Inter, sans-serif; padding: 10px;">' +
                '<h3 style="margin: 0 0 8px 0; color: #2f5964; font-size: 1.1rem; font-weight: 600;">Locatie</h3>' +
                '<a href="https://www.google.com/maps/dir/?api=1&destination=' + lat + ',' + lng + '" target="_blank" ' +
                'style="display: inline-block; margin-top: 4px; color: #d87d2f; font-size: 0.85rem; text-decoration: none; font-weight: 500;">' +
                'Route plannen →</a>' +
                '</div>';
            
            marker.bindPopup(popupContent, { maxWidth: 250 });
            
            // Scroll zoom interaction
            map.on('click', function() {
                map.scrollWheelZoom.enable();
                mapContainer.classList.add('map-active');
            });
            
            map.on('mouseout', function() {
                map.scrollWheelZoom.disable();
                mapContainer.classList.remove('map-active');
            });
            
            // Hide loading indicator
            var loading = mapContainer.querySelector('.map-loading');
            if (loading) {
                loading.style.display = 'none';
            }
            
        } catch (error) {
            console.error('Map initialization error:', error);
            mapContainer.innerHTML = 
                '<div style="display: flex; align-items: center; justify-content: center; height: 100%; ' +
                'background: #f8f4ed; color: #2f5964; font-family: Inter, sans-serif; flex-direction: column; padding: 20px; text-align: center;">' +
                '<p style="margin: 0 0 12px;">Kaart kon niet worden geladen</p>' +
                '<a href="https://www.google.com/maps/search/?api=1&query=' + lat + ',' + lng + '" target="_blank" ' +
                'style="color: #d87d2f; font-size: 0.9rem; text-decoration: underline;">Open in Google Maps</a>' +
                '</div>';
        }
    }
    
    // Initialize when ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMap);
    } else {
        initMap();
    }
    
})();


// ===================================
// FLIPCLOCK COUNTDOWN
// Safe initialization - won't crash if element doesn't exist
// ===================================

(function() {
    'use strict';
    
    // Check if countdown element exists
    const countdownEl = document.getElementById('countdown');
    if (!countdownEl) return;
    
    const countdownDate = countdownEl.getAttribute('data-countdown');
    if (!countdownDate) return;
    
    const targetDate = new Date(countdownDate).getTime();
    
    // Create flip clock structure
    function createFlipClock() {
        const clock = document.createElement('div');
        clock.className = 'flip-clock';
        
        const pieces = [
            { value: 0, label: 'Dagen' },
            { value: 0, label: 'Uren' },
            { value: 0, label: 'Minuten' },
            { value: 0, label: 'Seconden' }
        ];
        
        pieces.forEach((piece, index) => {
            const pieceEl = document.createElement('span');
            pieceEl.className = 'flip-clock__piece';
            pieceEl.innerHTML = `
                <b class="flip-clock__card card">
                    <b class="card__top">00</b>
                    <b class="card__bottom" data-value="00"></b>
                    <b class="card__back" data-value="00">
                        <b class="card__bottom" data-value="00"></b>
                    </b>
                </b>
                <span class="flip-clock__slot">${piece.label}</span>
            `;
            clock.appendChild(pieceEl);
        });
        
        countdownEl.appendChild(clock);
        return clock;
    }
    
    // Pad numbers with leading zero
    function pad(num) {
        return num < 10 ? '0' + num : num.toString();
    }
    
    // Flip card animation
    function flipCard(card, newValue) {
        const cardTop = card.querySelector('.card__top');
        const cardBottom = card.querySelector('.card__bottom');
        const cardBack = card.querySelector('.card__back');
        const cardBackBottom = cardBack.querySelector('.card__bottom');
        
        const currentValue = cardTop.textContent;
        if (currentValue === newValue) return;
        
        // Set new values
        cardBack.setAttribute('data-value', newValue);
        cardBackBottom.setAttribute('data-value', newValue);
        cardBottom.setAttribute('data-value', newValue);
        
        // Trigger flip animation
        card.parentElement.classList.remove('flip');
        void card.offsetWidth; // Force reflow
        card.parentElement.classList.add('flip');
        
        // Update top value after animation
        setTimeout(() => {
            cardTop.textContent = newValue;
            cardBottom.setAttribute('data-value', newValue); // Also update bottom
            card.parentElement.classList.remove('flip');
        }, 300);
    }
    
    // Update countdown
    function updateCountdown() {
        const now = new Date().getTime();
        const distance = targetDate - now;
        
        if (distance < 0) {
            // Countdown finished
            clearInterval(interval);
            return;
        }
        
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        const values = [
            pad(days),
            pad(hours),
            pad(minutes),
            pad(seconds)
        ];
        
        const pieces = clock.querySelectorAll('.flip-clock__piece');
        pieces.forEach((piece, index) => {
            const card = piece.querySelector('.card');
            flipCard(card, values[index]);
        });
    }
    
    // Initialize
    const clock = createFlipClock();
    updateCountdown(); // Initial update
    const interval = setInterval(updateCountdown, 1000);
    
})();